import { all, call, put } from 'redux-saga/effects';

import api from 'api';
import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { openModal } from 'store/modals/actions';
import { pauseSubscription } from 'store/subscriptions/actions';
import { checkAllPausedSubscriptions } from 'store/subscriptions/helpers';

import { CANCEL_OFFER_SUCCESS_SCREEN_ID } from 'constants/analytics';

import { trackScreenLoadCancelOffer } from 'services/Analytics';

import { ModalName } from 'modals/types';

import {
    getFreeMonthSuccessModalData,
    getRequestPauseSubscriptionErrorModalData,
    getRequestPauseSubscriptionWaitingModalData,
    pauseSuccessModalData,
} from 'helpers/subscriptions';

import { SubscriptionPauseType } from 'types/subscription';

import { pollGetSubscriptions } from './pollGetSubscriptions';
import { handleAuthError } from './utils';

export function* requestPauseSubscription({ payload }: ReturnType<typeof pauseSubscription>) {
    try {
        yield put(
            openModal(ModalName.WithLoaderModal, getRequestPauseSubscriptionWaitingModalData(payload.pause_type))
        );

        yield all(
            payload.externalIds.map((external_id) =>
                call(api.subscriptions.pauseSubscription, {
                    id: external_id,
                    provider: payload.provider,
                    pause_type: payload.pause_type,
                })
            )
        );

        const [firstSubscription]: ISubscriptionWellfunnel[] = yield call(
            pollGetSubscriptions,
            checkAllPausedSubscriptions(payload.externalIds)
        );

        const successModalInfo =
            payload.pause_type === SubscriptionPauseType.Pause
                ? pauseSuccessModalData
                : getFreeMonthSuccessModalData(firstSubscription.expired_date);

        if (firstSubscription) {
            yield put(openModal(ModalName.SuccessModal, successModalInfo));

            yield call(trackScreenLoadCancelOffer, {
                screenId: CANCEL_OFFER_SUCCESS_SCREEN_ID,
                eventLabel: { subscription_id: payload.externalIds, offer: successModalInfo.offer },
            });

            yield all(
                payload.externalIds.map((external_id) =>
                    call(api.subscriptions.sendPauseStatus, {
                        external_id,
                        pause_type: payload.pause_type,
                        provider: payload.provider,
                    })
                )
            );
        }
    } catch (error) {
        const authErrorWasHandled = yield* handleAuthError(error);

        if (authErrorWasHandled) return;

        yield put(
            openModal(ModalName.RetryErrorModal, {
                ...getRequestPauseSubscriptionErrorModalData(payload.externalIds, payload.pause_type),
                retryAction: () => pauseSubscription(payload),
            })
        );
    }
}
